// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { IFieldValueMapItem, IRisk } from 'types/graphql'

export interface OfflineState {
  risks: IRisk[]
  syncing: boolean
  currentRisk: Partial<IRisk> | null
}

const initialState: OfflineState = {
  risks: [],
  syncing: false,
  currentRisk: null
}

export const offlineRiskSlice = createSlice({
  name: Reducers.OFFLINE_RISK,
  initialState,
  reducers: (create) => ({
    setSyncing: create.reducer((state, action: PayloadAction<boolean>) => {
      state.syncing = action.payload
    }),
    addRisk: create.reducer(
      (
        state,
        action: PayloadAction<{
          riskId: string
          templateId: string
          createdAt: number
        }>
      ) => {
        state.currentRisk = {
          id: action.payload.riskId,
          riskTemplate: {
            id: action.payload.templateId
          }
        }

        const risk = {
          id: action.payload.riskId,
          createdAt: action.payload.createdAt,
          riskTemplate: {
            id: action.payload.templateId
          },
          fieldValueMap: []
        }

        state.risks = [...state.risks, risk]
      }
    ),
    setExistingRisk: create.reducer((state, action: PayloadAction<Partial<IRisk>>) => {
      state.currentRisk = action.payload
    }),
    removeRisk: create.reducer((state, action: PayloadAction<string>) => {
      state.risks = state.risks.filter((risk) => risk.id !== action.payload)
    }),
    addRiskFieldValue: create.reducer(
      (
        state,
        action: PayloadAction<{
          riskId: string
          fieldValue: IFieldValueMapItem
        }>
      ) => {
        state.risks = state.risks.map((risk) => {
          if (risk.id === action.payload.riskId) {
            if (risk.fieldValueMap.every((item) => item.fieldValueId !== action.payload.fieldValue.fieldValueId)) {
              return { ...risk, fieldValueMap: [...risk.fieldValueMap, action.payload.fieldValue] }
            }

            return {
              ...risk,
              fieldValueMap: risk.fieldValueMap.map((item) => {
                if (item.fieldValueId === action.payload.fieldValue.fieldValueId) {
                  return {
                    ...item,
                    ...action.payload.fieldValue
                  }
                }

                return item
              })
            }
          }

          return risk
        })
      }
    )
  }),
  selectors: {
    isSyncingSelector: (state) => state.syncing,
    offlineRiskSelector: (state) => state.currentRisk,
    offlineRisksSelector: (state) => state.risks
  }
})

export const { setSyncing, addRisk, removeRisk, setExistingRisk, addRiskFieldValue } = offlineRiskSlice.actions

export const { offlineRisksSelector, offlineRiskSelector, isSyncingSelector } = offlineRiskSlice.selectors
